module.exports = __webpack_public_path__ + "media/paliwa/lpg-cd5c45d0.png";